import styled from 'styled-components';

export const EndorsementsTestimonialsSection = styled.section`
    width: 100%;
    position: relative;
    background: #F1FEFF;
    padding: 58px 0px 50px;

    @media screen and (max-width: 480px){
        padding: 40px 0px 50px;
    }

    &::before{
        content: '';
        position: absolute;
        background: #DDF5F6;
        width: 100%;
       height:100%;
        top: 0px;
        left: 0;
        right:0;
        z-index: 0;
    }

    &.endorsements-banner{
        @media screen and (max-width: 1024px){
            padding-top: 170px;
        }
    }
`;

export const EndorsementsTitle = styled.h2`
    position: relative;
    color: #01606F;
    font-size: 40px;
    font-family: 'Jost', sans-serif;
    font-weight: 700;
    line-height: 58px;
    z-index: 2;

    @media screen and (max-width: 991px){
        font-size: 36px;
        line-height: 56px;
    }

    @media screen and (max-width: 767px){
        font-size: 32px;
        line-height: 54px;
    }

    @media screen and (max-width: 575px){
        font-size: 30px;
        line-height: 50px;
    }
`;

export const TestimonialsListWrap = styled.div`
    background: #FFFFFF;
    margin-top: 30px;
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    row-gap: 20px;
    border-radius: 20px;
    position: relative;
    box-shadow: 0px 20px 20px #0000001A;
    z-index: 2;

    .social-media-requests-box-title{
        display: none;
    }

    .social-media-req-ul{
        display: none;
    }

     .dash-review{
        display:none;
     }

    .reviews-content-text {
        margin: 12px 0 10px;
    }
`;


